/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PrimaryLight/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ColorTextInput from './ColorTextInput/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function PrimaryLight({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/Theme/PrimaryLight"
  
}) {
let settingsThemeoverrideLightValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'themeOverride.light',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Primary light variant"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<React.Fragment>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="color"
 width={40}
 data="settings.themeOverride.light"
 value={settingsThemeoverrideLightValueData}
 onChange={onChange}
/>
<ColorTextInput
{...childProps}
  viewPath={`${viewPath}/ColorTextInput`}
/>
</React.Fragment>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}